export const QLIK_APP_REF = "cyber-index";
export const THEME: string = "theme-chubb"
export const INDUSTRY_FIELD = "Industry"
export const CLASS_DESCRIPTION_FIELD = "Class Description"
export const COMPANY_ANNUAL_REV_FIELD = "Company Annual Revenue"
export const INTERNATIONAL_VALUE = "International"
export const DATE_RANGE_FIELD = "Date Range"
export const REGION_FIELD = "Region"
export const FILTER_REMOVE_VALUES = ['Rolling 12 Months','Current Year','Last Complete Year']